import React from 'react';
import ReactMarkdown from 'react-markdown';

const HTML_CONTENT_REGEX = /<\/?[a-z][\s\S]*>/i;

const PreviewCard = (props) => {
  const color = props.color || 'green';

  function handleNavigation() {
    if (props.externalLink) {
      window.open(props.link, '_blank', 'noopener,noreferrer');
    } else {
      window.location.href = props.link;
    }
  };

  let accessibleLabel =
    props.ariaLabel || `Read more${props.title ? ` about ${props.title}` : ''}`;
  if (props.externalLink) {
    accessibleLabel += ' (opens in a new tab)';
  }

  const isHtmlContent = typeof props.content === 'string' && HTML_CONTENT_REGEX.test(props.content);

  return (
    <div className={`preview-card-link ${color} focus-on-light`}>
      {isHtmlContent
        ? <div className="preview-card" dangerouslySetInnerHTML={{ __html: props.content }} />
        : <div className="preview-card"><ReactMarkdown>{props.content}</ReactMarkdown></div>}
      <button
        aria-label={accessibleLabel}
        className={`quill-button small contained focus-on-light ${color}`}
        onClick={handleNavigation}
        role="link"
      >
        {props.buttonText || 'Read'}
      </button>
    </div>
  );
};

export default PreviewCard;
